<div id="application-wrapper" class="app-wrapper new-global-nav-theme">
  <div id="application-content" class="app-content">
    <invd-fm-header
      class="fixed-header"
      [userName]="displayName"
      [userLinks]="logoutLink"
      (bannerExitIconClick)="exitBannerIconClick($event)"
    ></invd-fm-header>

    <invd-fm-app-navigation-menu [menu]="menu"></invd-fm-app-navigation-menu>

    <router-outlet></router-outlet>

    <!-- <div class="push-footer"></div> -->
  </div>
  @if (showSessionExtendPopup$) {
    <div class="enter-mega-model-window">
      <div class="panel panel-default fadeInUpBig">
        <div class="row">
          <div class="col-sm-12 col-12 col-md-12 col-lg-12">
            <h2 class="session-timeout-header">Session Timeout</h2>
          </div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break-popup">
            <div class="line-break"></div>
          </div>
        </div>
        <div class="panel-body mega-cancel-confirmation-model session-timeout-msg">
          <p>
            You have been idle for more than {{ screenIdleTime }} minutes. You will be signed out in
            <span class="timerStyle">{{ timeLeft }} seconds</span>. Click Yes to continue working,
            or click No to end the session.
          </p>
          <button class="button fm-primary-button" (click)="callHealthCheckService()">Yes</button>
          <button class="button fm-tertiary-button" (click)="closeAndLogOut()">No</button>
        </div>
      </div>
    </div>
  }
</div>

<footer class="footer new-global-nav-theme">
  <div class="footer-verbiage">© {{ currentYear }} Fannie Mae. All rights reserved.</div>
</footer>

<invd-fm-loading-page
  [isRunning]="fmLoadingPageService.isLoaderRequesting()"
></invd-fm-loading-page>
